/* eslint-disable */
import { compose, branch, renderNothing, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { list } from 'ggApp/modules/category/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';

import ClickOutside from 'react-click-outside';

import Content from './Content';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            categoryList: list,
        }),
    ),
    branch(({ categoryList }) => !categoryList.data, renderNothing),
    withProps(({ activeStore: { country_code, code }, categoryList }) => ({
        categories: categoryList.data || null,
        countryCode: country_code.toLowerCase(),
        storeCode: code,
    })),
    ClickOutside,
);

export default enhance(Content);
